import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-device',
    templateUrl: './device-virtual.component.html',
    providers: [],
})
export class DeviceVirtualComponent  {


  constructor(
      private store: Store<AppState>,
      private route: ActivatedRoute,
      private translate: TranslateService,
  ) {
  }

}
